// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-container>div{display:inline-block}.badge-item{white-space:nowrap;margin-top:2px;margin-right:12px}", ""]);
// Exports
module.exports = exports;
